<template>
    <transition
        :css="false"
        @enter="enter"
        @leave="leave"
        @after-enter="$emit('after-enter')"
    >
      <slot></slot>
    </transition>
</template>

<script>
    export default {
        name: "HeightTransition",

        props: {
            initialShow: {
                type: Boolean,
                default: false
            },

            duration: {
                type: Number,
                default: 300
            }
        },

        data() {
            return {
                show: this.initialShow,
                height: 0,
                marginTop: null,
                marginBottom: null,
                paddingTop: null,
                paddingBottom: null,
                startTime: null,
                transitionCallback: null
            }
        },

        methods: {
            enter(el, done) {
                if (!this.show) this.animate(el, done);
            },


            leave(el, done) {
                let computedStyle = window.getComputedStyle(el);
                this.show = computedStyle.display !== 'none' ? true : this.show;
                this.animate(el, done);
            },

            animate(el, done) {
                this.getHeight(el);

                var elmStyles = window.getComputedStyle(el);
                this.marginTop     = parseInt(elmStyles.getPropertyValue("margin-top"));
                this.marginBottom  = parseInt(elmStyles.getPropertyValue("margin-bottom"));
                this.paddingTop    = parseInt(elmStyles.getPropertyValue("padding-top"));
                this.paddingBottom = parseInt(elmStyles.getPropertyValue("padding-bottom"));

                this.transitionCallback = done;
                this.startTime = new Date().getTime();

                el.style.cssText = "overflow: hidden;";
                this.step(el);
            },

            step(el) {
                let time = new Date().getTime() - this.startTime;
                time = time / this.duration;

                this.updateStyleProperty(el, 'height', this.updateStepValue(this.height, time) + 'px');
                this.updateStyleProperty(el, 'opacity', !this.show ? Math.min(time, 1) : Math.max(1 - time, 0));

                if (this.marginTop) this.updateStyleProperty(el, 'margin-top', this.updateStepValue(this.marginTop, time) + 'px');
                if (this.marginBottom) this.updateStyleProperty(el, 'margin-bottom', this.updateStepValue(this.marginBottom, time) + 'px');
                if (this.paddingTop) this.updateStyleProperty(el, 'padding-top', this.updateStepValue(this.paddingTop, time) + 'px');
                if (this.paddingBottom) this.updateStyleProperty(el, 'padding-bottom', this.updateStepValue(this.paddingBottom, time) + 'px');

                if (time < 1) {
                    window.requestAnimationFrame(this.step.bind(this, el));
                } else {
                    el.removeAttribute('style');
                    this.show = !this.show;
                    this.transitionCallback();
                }
            },

            updateStepValue(endValue, time) {
                return !this.show
                    ? Math.min(0 + (endValue - 0) * this.ease(time), endValue)
                    : Math.max(endValue + (0 - endValue) * this.ease(time), 0);
            },

            updateStyleProperty(el, prop, val) {
                el.style.setProperty(prop, val, 'important');
            },

            getHeight(el) {
                let display = el.style.display;
                let visibility = el.style.visibility;
                el.style.visibility = "hidden";
                el.style.display = "";
                this.height = el.offsetHeight;
                el.style.display = display;
                el.style.visibility = visibility;
            },

            ease(t) {
                var f = t - 1.0;
		        return f * f * f + 1.0;
            }
        }
    }
</script>
